import { createContext, useContext } from "react";

type RatesErrorHandler = (message: string) => void;

const RatesErrorContext = createContext<RatesErrorHandler | undefined>(
  undefined,
);

export const RatesErrorProvider = RatesErrorContext.Provider;

export const useRatesErrorHandler = (): RatesErrorHandler | undefined =>
  useContext(RatesErrorContext);
